import React from "react";
import { OrderList } from "../../types/orderTypes";
import { Order } from "src/shared/services/interfacev2";
import { splitDateTime } from "src/shared/components/dateTime";
import { useDateTimeFormatter } from "src/shared/configurations/hooks/useDateTimeFormatter";

interface Props {
  selectedOrder: Order;
  themeTextColor: string;
  getLightBgClass: () => string;
  isCancelled: boolean;
  isCompleted: boolean;
}

const CustomerInfoCard: React.FC<Props> = ({ selectedOrder, themeTextColor, getLightBgClass, isCancelled, isCompleted }) => {
  const { formatDate } = useDateTimeFormatter();
  const { date: orderDate } = splitDateTime(selectedOrder?.orderDetails[0].orderedOn.$date ?? "");
  const rows = [
    { label: "Customer Name", value: [selectedOrder.customerDetails.firstName, selectedOrder.customerDetails.middleName, selectedOrder.customerDetails.lastName].filter(Boolean).join(" ") || "", },
    { label: "Order Date", value: formatDate(orderDate)  || "Not specified", },
    { label: "Order ID", value: selectedOrder.orders[0].orderId || "N/A", },
    { label: "Status", value: isCancelled ? "Cancelled" : isCompleted ? "Completed" : "Pending",
      className: isCancelled ? "text-red-600 font-semibold" : isCompleted ? "text-green-600 font-semibold" : "text-amber-600 font-semibold",
    },
  ];

  return (
    <div className={`bg-white rounded-xl border border-gray-200 p-3 mb-2.5 shadow-sm`}>
      <h3 className={`text-lg font-semibold ${themeTextColor} mb-3 flex items-center gap-2`}>
        <i className="fas fa-user-circle text-lg"></i> Customer Information
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {rows.map((row, index) => (
          <div key={index} className="flex justify-between items-center py-1 border-b border-gray-100">
            <span className="font-medium text-gray-700 text-sm">{row.label}</span>
            <span className={`text-sm font-semibold ${row.className || themeTextColor}`}>{row.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerInfoCard;
